// extracted by mini-css-extract-plugin
export default {"root":"CookiesNotice_root__M-HYu","header":"CookiesNotice_header__rK7nI","accept":"CookiesNotice_accept__0lT6j"};